var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayerBg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 646,
    height: 109,
    fill: "none",
    viewBox: "0 0 646 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "player_bg_01",
    width: 646,
    height: 109,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 646,
    height: 109,
    fill: "#D9D9D9",
    rx: 54.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#player_bg_01)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.5,
    cy: 17.5,
    fill: "#9C9C9C",
    rx: 44.5,
    ry: 41.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94,
    cy: 3.5,
    fill: "#9C9C9C",
    rx: 68,
    ry: 41.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.251,
    cy: 0.3,
    fill: "#9C9C9C",
    rx: 48.943,
    ry: 41.5,
    transform: "rotate(22.951 143.251 .3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.251,
    cy: 109.3,
    fill: "#9C9C9C",
    rx: 48.943,
    ry: 41.5,
    transform: "rotate(22.951 309.251 109.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.251,
    cy: 131.3,
    fill: "#9C9C9C",
    rx: 48.943,
    ry: 41.5,
    transform: "rotate(22.951 363.251 131.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.251,
    cy: -22.7,
    fill: "#9C9C9C",
    rx: 48.943,
    ry: 41.5,
    transform: "rotate(22.951 164.251 -22.7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 552.251,
    cy: 11.3,
    fill: "#9C9C9C",
    rx: 48.943,
    ry: 41.5,
    transform: "rotate(22.951 552.251 11.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 605.251,
    cy: 24.3,
    fill: "#9C9C9C",
    rx: 48.943,
    ry: 41.5,
    transform: "rotate(22.951 605.251 24.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 658.251,
    cy: 48.3,
    fill: "#9C9C9C",
    rx: 48.943,
    ry: 41.5,
    transform: "rotate(22.951 658.251 48.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.251,
    cy: -8.7,
    fill: "#848484",
    rx: 48.943,
    ry: 41.5,
    transform: "rotate(22.951 576.251 -8.7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 635.142,
    cy: -1.124,
    fill: "#848484",
    rx: 68.371,
    ry: 41.5,
    transform: "rotate(16.05 635.142 -1.124)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.18,
    cy: -21.215,
    fill: "#848484",
    rx: 68.371,
    ry: 41.5,
    transform: "rotate(16.05 57.18 -21.215)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.685,
    cy: -13.336,
    fill: "#848484",
    rx: 37.437,
    ry: 24.26,
    transform: "rotate(16.05 158.685 -13.336)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.685,
    cy: 121.664,
    fill: "#848484",
    rx: 37.437,
    ry: 24.26,
    transform: "rotate(16.05 325.685 121.664)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerBg01);
export default __webpack_public_path__ + "static/media/player_bg_01.c522466f3067888df8f31c40ca8e1265.svg";
export { ForwardRef as ReactComponent };